import * as actions from "Actions";
import * as api from "Api";

export const fetchTrees = ({ limit, scope }) => {
  return (dispatch, getState) => {
    // let sourceToken = pushSourceToken("FETCH_LATEST_ARTICLES", dispatch);

    const { lng } = getState().params;
    const { token, navCommunity, user } = getState().auth;

    return dispatch(
      actions.fetchTrees(
        api.getTrees({
          token,
          limit: limit,
          language: lng,
          scope,
          user,
          community: navCommunity ? navCommunity.id : null /*, sourceToken*/
        })
      )
    );
  };
};

export const saveTree = ({ id, tree }) => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      actions.saveTree(
        api.saveTree({
          token,
          id,
          tree,
          community: navCommunity ? navCommunity : null /*, sourceToken*/
        })
      )
    );
  };
};

export const deleteTree = id => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(
      actions.deleteTree(
        api.deleteTree({
          token,
          id
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/tree.js